
import React, {
  ForwardRefRenderFunction,
  forwardRef,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { useTranslation } from "react-i18next";

import { CommodityCode } from "../../../../../../../../models/commodity.code";
import { SectionView } from "../../../../../../../../components/Generic/SideView/SectionView";
import { Modal } from "./styles"
import { formatHSCode } from "../../utils";
import { Color } from "../../../../../../../../components/Form/Button";

export interface ViewCommodityCodeHandles {
  open: (commodityCode: CommodityCode) => void;
  close: () => void;
}

interface Props { }

const ViewCommodityCodeModal: ForwardRefRenderFunction<ViewCommodityCodeHandles, Props> = (_, ref) => {
  const { t: translate } = useTranslation();

  const [commodityCode, setCommodityCode] = useState<CommodityCode>();
  const [modalOpened, setModalOpened] = useState<boolean>(false);

  const openModal = useCallback((code: CommodityCode) => {
    setCommodityCode(code);
    setModalOpened(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalOpened(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open: openModal,
    close: closeModal,
  }));

  const hscode = formatHSCode(commodityCode?.hscode || "")

  const title = `${translate("hsCommodityCode")} '${hscode}'`;

  const fields = [[
    {
      label: translate("code"),
      value: hscode,
      collapse: false,
    },
    {
      label: `${translate("section")} ${commodityCode?.sectionEntity?.code || ""}`,
      value: commodityCode?.sectionEntity?.description,
      collapse: false,
    },
    {
      label: `${translate("chapter")} ${commodityCode?.chapterEntity?.code || ""}`,
      value: commodityCode?.chapterEntity?.description,
      collapse: false,
    },
    {
      label: `${translate("description")}`,
      value: commodityCode?.description,
      collapse: false,
    },
    {
      label: translate("statisticalClassification"),
      value: commodityCode?.statisticalClassification,
      collapse: false,
    },
    {
      label: translate("applicableTo"),
      value: commodityCode?.regions ? commodityCode?.regions.map((region) => region.name).join(", ") : undefined,
    },
  ]]

  return (
    <Modal
      title={title}
      open={modalOpened}
      handleClose={closeModal}
      showModalFooter={false}
    >
      <div>
        <SectionView noPadding md={12} fields={fields} />
      </div>
    </Modal>
  );
};

export default forwardRef(ViewCommodityCodeModal);
